import React, { useEffect } from 'react'
import styles from '../../modal.module.css'
import caretDown from '../../../images/caretDownGeneric.svg'
import { countryOptions } from './utils/countries'
import useFilterStore from '../../../../Store/filterStore' // Adjust the path as needed
import Province from './province'
import City from './city'
import Address from './address'
import PostalCode from './postalCode'
import Neighborhood from './Neighborhood/Neighborhood'
import infoIcon from './../images/circle-info-regular-full.svg'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import County from './county'

const useTooltipStyles = makeStyles({
  tooltip: {
    display: 'inline-block',
    width: 'auto',
    maxWidth: 500,
    fontSize: '13px',
    padding: '8px',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    textAlign: 'left',
    wordBreak: 'break-word'
  }
})

function LocationSection ({
  localFilters,
  setLocalFilters,
  setLocationChanged
}) {
  const { allFilters } = useFilterStore()

  const toolTipClasses = useTooltipStyles()
  const {
    streetAddress,
    city,
    stateProvince,
    postalCode,
    country,
    neighborhood
  } = allFilters

  // Update local state when global state changes
  useEffect(() => {
    setLocalFilters({
      streetAddress: streetAddress,
      city: city,
      stateProvince: stateProvince,
      postalCode: postalCode,
      country: country,
      neighborhood: neighborhood
    })
  }, [
    streetAddress,
    city,
    stateProvince,
    postalCode,
    country,
    neighborhood,
    setLocalFilters
  ])

  // Handlers for each input
  const handleLocationFieldsChange = e => {
    const { id, value } = e.target
    setLocationChanged(true)
    setLocalFilters(prevFilters => ({
      ...prevFilters,
      [id]: value
    }))
  }

  return (
    <section>
      <form className={styles.locationSection}>
        <div className={styles.sectionTitleWithIcon}>
          <span className={styles.sectionTitle}>Location</span>
        </div>
        <div
          style={{
            fontSize: 12,
            color: '#777',
            marginTop: -4,
            marginBottom: 8
          }}
        >
          Press <kbd
            style={{
              display: 'inline-block',
              padding: '0 4px',
              border: '1px solid #ccc',
              borderRadius: 3,
              fontFamily: 'monospace',
              fontSize: 11,
              background: '#f5f5f5'
            }}
          >Enter</kbd> to add each value.
        </div>
        <div className={styles.inputGroup}>
          {/* Street Address */}
          <Address
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />
          {/* City */}
          <City
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />
          {/* State or Province */}
          <Province
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />

          {/* Postal Code */}
          <PostalCode
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />
          <Neighborhood
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />

            <County
            setLocalFilters={setLocalFilters}
            setLocationChanged={setLocationChanged}
          />
          {/* Country */}
          <div className={styles.inputColumn}>
            <div className={styles.sectionTitleWithIcon}>
              <span className={styles.labelLocation} htmlFor='country'>
                Country
              </span>
              <Tooltip
                title='Filter by the country where the property is located.'
                arrow
                placement='top'
                classes={{ tooltip: toolTipClasses.tooltip }}
              >
                <img
                  src={infoIcon}
                  alt='Country info'
                  width={14}
                  height={14}
                  className={styles.infoIcon}
                />
              </Tooltip>
            </div>
            <div>
              <select
                className={styles.customSelectLocation}
                id='country'
                value={localFilters.country}
                onChange={handleLocationFieldsChange}
              >
                <option value=''>Any</option>
                {countryOptions.map((countryOption, index) => (
                  <option
                    className={
                      countryOption === '--'
                        ? styles.separatorOption
                        : styles.option
                    }
                    key={index}
                    value={countryOption === '--' ? '' : countryOption}
                    disabled={countryOption === '--'}
                  >
                    {countryOption === '--' ? '-----' : countryOption}
                  </option>
                ))}
              </select>
              <img src={caretDown} alt='arrow' className={styles.customArrow} />
            </div>
          </div>
        </div>
      </form>
      <hr className={styles.hrStyle} />
    </section>
  )
}

export default LocationSection
